import {useEffect, useState} from "react";
import {X} from "lucide-react";
import {validateCancelReason} from "../contracts";
import {useTranslation, i18n} from "../../../shared/i18n";


const mutationError = (error) => error?.response?.data?.message || error?.message || i18n.t("sections.inbox.p60");

export const ReviewCancelDialog = ({review, mutation, onClose}) => {
    const {t} = useTranslation();
    const [reason, setReason] = useState("");
    const [validationError, setValidationError] = useState("");

    useEffect(() => {
        setReason("");
        setValidationError("");
        mutation.reset();
    }, [review]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!review) return null;

    const submit = (event) => {
        event.preventDefault();
        const error = validateCancelReason(reason);
        setValidationError(error);
        if (error) return;
        mutation.mutate({id: review.id, type: review.type, text: reason.trim()});
    };

    return (
        <div className="inbox-dialog-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && !mutation.isPending && onClose()}>
            <section className="inbox-dialog" role="dialog" aria-modal="true" aria-labelledby="review-cancel-title">
                <header><div><p className="admin-eyebrow">{t("sections.inbox.p61")}</p><h2 id="review-cancel-title">{t("sections.inbox.p62")}</h2></div><button type="button" aria-label={t("sections.inbox.p63")} disabled={mutation.isPending} onClick={onClose}><X size={18} /></button></header>
                <p className="inbox-dialog-review">{review.text}</p>
                <form onSubmit={submit}>
                    <label htmlFor="review-cancel-reason">{t("sections.inbox.p64")}</label>
                    <textarea id="review-cancel-reason" aria-label={t("sections.inbox.p64")} value={reason} onChange={(event) => {setReason(event.target.value); setValidationError("");}} rows="4" autoFocus />
                    {validationError ? <p className="inbox-field-error" role="alert">{validationError}</p> : null}
                    {mutation.isError ? <p className="inbox-field-error" role="alert">{mutationError(mutation.error)}</p> : null}
                    <footer><button type="button" className="inbox-secondary-button" disabled={mutation.isPending} onClick={onClose}>{t("sections.inbox.p65")}</button><button type="submit" className="inbox-danger-button" disabled={mutation.isPending}>{mutation.isPending ? t("sections.inbox.p66") : t("sections.inbox.p62")}</button></footer>
                </form>
            </section>
        </div>
    );
};
